/***** body addclass *****/
$(document).ready(function(){
  var loc = location.pathname.split('/');
  var locclr = loc.filter(Boolean);
  var dirName = locclr[locclr.length -1];

  if ( locclr.length === 0 || dirName === 'en' || dirName === 'fr' || dirName === 'ko' || dirName === 'zh' ){
      $('body').addClass('top');
  } else {
      $('body').addClass(dirName);
  }
});
/***** /body addclass *****/





/***** div addclass *****/
$(document).ready(function(){
  /* SHOP ID */
    const shopId = '#shopify-section-template--20655900721370__';
    const shopproductId = '#shopify-section-template--20655900426458__';
  /* /SHOP ID */
  
  /* hero */
    $(shopId + "image_slideshow_7tdFfq").addClass('heroslider');
  /* /hero */

  /* recommendkeyword */
    $(shopId + "ce87fd9a-23d7-48de-b6c5-6751a32507d7").addClass('recommendkeyword');
  /* /recommendkeyword */

  /* bestseller */
    $(shopId + "a6ec73a5-107e-47c9-be63-9963973d7c2f").addClass('bestseller_ttl');
    $(shopId + "46c0157a-210a-4845-87cf-67e91d036ddc").addClass('bestseller_item');
  /* /bestseller */

  /* itemlink */
    $(shopId + "beab8282-46ae-4209-8cec-cd9f4445a85d").addClass('itemlink');
  /* /itemlink */

  /* favorite-button */
    $(shopproductId + "171256688092632fba").addClass('favoritebtn_wrapper');
  /* /favorite-button */

  /* footer_detail */
    $(shopId + "3517a3d8-b87e-46c4-ae6c-a81f608c8a79").addClass('footer_detail');
  /* /footer_detail */
});

/* bestseller_numbering */
  $(function(){
    $('.bestseller_item .grid__item').each(function(i){
      // $(this).attr('id','item' + (i+1));
      $(this).append('<span>' + (i+1) + '</span>');
    });
  });
  $(function(){
    $(window).on('load scroll', function() {
      $('body#best-selling div#template--collection > .grid__item > span').remove();
      $('body#best-selling div#template--collection > .grid__item').each(function(i){
        $(this).append('<span>' + (i+1) + '</span>');      
      });
    });
  });
/* /bestseller_numbering */
/***** /div addclass *****/





/***** /navi *****/
$(function(){
  $('.contentMenu > nav').each(function () {
    var $window = $(window),
    $nav = $(this),
        navOffsetTop = $nav.offset().top - 100;
        $window.on('scroll', function () {
        if ($window.scrollTop() > navOffsetTop) {
          $nav.addClass('fixed');
          $(this).css({display: 'none'});
          // $('body').prepend('<nav class="fixed"><ul><li><a href="#">購入</a></li><li><a href="#">注文者登録</a></li><li><a href="#">配送選択</a></li><li><a href="#">お支払い</a></li><li><a href="#">キャンセル・返品・交換</a></li></ul></nav>');
        } else if ($window.scrollTop() <= navOffsetTop) {
          $nav.removeClass('fixed');
          $(this).css({display: 'block'});
          // $('body > nav.fixed').remove();
        }
    });
    $window.trigger('scroll');
  });
});

$(function(){
  // 指定した条件(.guide2)の子要素を持つ親要素
  $('div.grid__item:has(.guide2)').addClass('guide2_header');
});
/***** /navi *****/





/***** about us | caution | contact phase3 *****/
$(function(){
  // 指定した条件(.guide2)の子要素を持つ親要素
  $('div#PageContainer:has(.guide_p3)').addClass('pagecontent_p3');
  $('div#PageContainer:has(.form_p3)').addClass('pagecontent_form_p3');
});

$(function() {
  $('.pagecontent_p3 section.guide2 ul > li > h3').on('click', function() {
    $(this).toggleClass('open');
    $(this).nextAll().toggleClass('open');
  });
});

/* faq */
  $(function() {
    $('.pagecontent_p3 section.faq_p3 ul > li > h4').on('click', function() {
      $(this).toggleClass('open');
      $(this).next('p').toggleClass('open');
    });
  });
/* /faq */
/***** /about us | caution | contact phase3 *****/





/***** anchor *****/
$(function () {
    // var headH = $('header').outerHeight();
    // var navH = $('nav').outerHeight();
    // var sclH = headH + navH;
    var animeSpeed = 500;
    $("section#userGuide a[href^='#']").on({
        "click": function () {
            var href = $(this).attr('href');
            var target = $(href == "#" || href === "" ? "html" : href);
            var position;
            position = target.offset().top - 140;
            $("body,html").stop().animate({
                scrollTop: position
            }, animeSpeed);
            return false;
        }
    });
});
/***** /anchor *****/





/***** announce txt *****/
/*  */$(document).ready(function(){
  $('div.announcement-bar-inner').remove();
  $('div.announcement-bar').prepend('<ul><li class="fadeout">日本/世界各国へ発送</li><li class="fadein">転送/代理購入サービス不要</li></ul>');
});

/* $(function () {
  $('div.announcement-bar ul li').on({
      'click': function () {
        window.location.href='/';
      }
  });
}); */

/* slick 
document.addEventListener('DOMContentLoaded', function() {
  let count = 0;
  const destroy = setInterval(function() {
    const target = document.querySelector('.announcement-bar ul.importantnotice li');
    count = count + 1;
    if (target) {
      clearInterval(destroy);

      $(document).ready(function(){     
          $('.announcement-bar ul.importantnotice').slick({
            arrows: false,
            autoplay: true,
            autoplaySpeed: 4000,
            cssEase: 'ease',
            draggable: false,
            pauseOnHover: true,
            slidesToShow: 1,
            speed: 1000,
      
            responsive: [
              {
                breakpoint: 812,
                settings: {
                  arrows: false,
                  autoplay: true,
                  autoplaySpeed: 4000,
                  cssEase: 'ease',
                  draggable: false,
                  pauseOnHover: true,
                  slidesToShow: 1,
                  swipe: false,
                  speed: 1000,
                }
              }
            ]
          });
        });
    }
  }, 10);
  setTimeout(function() {
    clearInterval(destroy);
  }, 20000);
})
        /slick */

/***** /announce txt *****/





/***** accordion *****/
$(function() {
  $('.acdn .acdn_btn').on('click', function() {
    $(this).toggleClass('acdn_show');
  });
});

$(function() {
  $('button#AddToCart').on('click', function() {
    $('p.cart-all').addClass('show');
  });
});

/* buy-detail */
  $(function() {
    $('ul.buy_detail h3').on('click', function() {
      $(this).toggleClass('open');
      $(this).next('dl').toggleClass('open');
      // $(this).parent('dl.acd').toggleClass('acd_open');
      // $(this).next().children('p').slideToggle(500);
      // $(this).next('dl > dt').slideToggle(500);
      // $(this).next('dl > dd:not(.payicon)').slideToggle(500);
    });
  });
/* /buy-detail */

/* collection filter */
  $(function() {
    $('p.facets__heading').on('click', function() {
      $(this).siblings('details').toggleClass('collection_filter_show');
    });
  });
  
  $(function() {
    $('.disclosure-has-popup').on('click', function() {
      // $('.disclosure-has-popup').toggleClass('collection_filter_show');
      // $('.disclosure-has-popup').removeClass('collection_filter_show');
      // $(this).addClass('collection_filter_show');
    });
  });

  $(function() {
    $('label.collection-filters__label').on('click', function() {
      $(this).next('div.select').toggleClass('collection_filter_show');
    });
  });
/* /collection filter */

/* order_list */
  $(function() {
    $('div.order_list > div').on('click', function() {
      $(this).toggleClass('order_detail_show');
    });
  });
/* /order_list */

/***** /accordion *****/





/***** search *****
$(document).ready(function(){
  $('div.header-section--wrapper').prepend('<form action="/search" method="get" role="search" class="search"><div class="field"><button type="submit" class="search__button field__button" aria-label="Translation missing: ja.general.search.search"></button></div></form>');
});
***** search *****/





/***** modal *****/
var $body = $('body');
var scrollTop;

function bodyFixedOn() {
  scrollTop = $(window).scrollTop();  
  $body.css({position: 'fixed', top: -scrollTop, width: '100%'});
  $('section.modal_switcher').removeClass('hide').addClass('show');
}

function bodyFixedOff() {
  $body.css({position: '', top: '', width: 'auto'});
  $(window).scrollTop(scrollTop);
  $('section.modal_switcher').removeClass('show').addClass('hide');
}

$('.modal_trigger').on('click', function() {
  bodyFixedOn();
});

$('.modal_close').on('click', function() {
  bodyFixedOff();
});

$('.overlay').on('click', function() {
  bodyFixedOff();
});
/***** /modal *****/





/***** switcher *****/
$(function () {
  var paraGety = function paraGety(para) {
    var pageURL = window.location.search.substring(1),
    urlValue = pageURL.split('&'), paraName;
    for(var i = 0; i < urlValue.length; i++) {
      paraName = urlValue[i].split('=');
      if (paraName[0] === para) {
        return paraName[1] === undefined ? true : decodeURIComponent(paraName[1]);
      }
    }
  };
  var result = paraGety('currency');
  var cry = (result == undefined) ? 'jpy' : (result == 'jpy') ? 'jpy' : (result == 'usd') ? 'usd' : (result == 'cad') ? 'cad' : (result == 'aud') ? 'aud' : (result == 'gbp') ? 'gbp' : (result == 'eur') ? 'eur' : (result == 'cny') ? 'cny' : (result == 'krw') ? 'krw' : (result == 'hkd') ? 'hkd' : (result == 'twd') ? 'twd' : '';
  $('section.modal_switcher > nav > dl:nth-of-type(2) > dd#'+ cry +' > a').css({background: '#000', color: '#fff'});
});

$(function() {
  $('.switcher_box dt').on('click', function() {
    $('.switcher_box dd').toggleClass('show').removeClass('hide');
  });
});
/***** /switcher *****/





/***** a no link *****/
$(function(){
  $('a.nolink').on('click', function() {
    return false;
  });
});
/***** /a no link *****/





/***** footer logo href *****/
$(function () {
  $('footer.site-footer div.wrapper-padded div.grid div.grid__item.large--one-third.medium--one-half.small--one-whole.image-footer div.image-bar__item div.image-bar__content div.responsive-image-wrapper img.js').on({
      'click': function () {
        window.location.href='/';
      }
  });
});
/***** /footer logo href *****/





/***** labeling dummy *****
$(function(){
  $(window).on('load', function() {
    $('.bestseller_item .grid-uniform > div.grid__item').prepend('<div class="labellist"><span class="label_preorder">予約</span><span class="label_benefits">限定特典</span><span class="label_limited">ファンクラブ限定</span><span class="label_benefits">特典</span></div>');      
  });
});
$(function(){
  $(window).on('load', function() {
    $('body.template-collection #CollectionProductGrid #template--collection > div.grid__item').prepend('<div class="labellist"><span class="label_preorder">予約</span><span class="label_benefits">限定特典</span><span class="label_limited">ファンクラブ限定</span><span class="label_benefits">特典</span></div>');      
  });
});
***** labeling dummy *****/





/***** collection all title
$(document).ready(function(){
  $('body.template-collection.all h1.page--title').html('ALL ITEMS');
});
/collection all title *****/





/***** collection filter_tags *****/
$(function () {
  if ($(window).width() <= 768) {
    var cnt = $('.filter_tags > li').length
    if( cnt >= 5){
      console.log('aaa');
      $('.filter_tags').prepend('<li class="filter_tags_btn">></li>')
    }
  }
});
  
$(function () {
  $('.filter_tags_btn').on({
    'click': function () {
      $('.filter_tags').toggleClass('filter_tags_open');
    }
  });
});
/***** /collection filter_tags *****/





/***** date *****/
jQuery(function($) {
  jQuery.extend({
    clock : function clock(target){
        var dayOfTheWeek = new Array("Sun","Mon","Tue","Wed","Thu","Fri","Sat");
        var now  = new Date();
        var year = now.getFullYear();
        var month = now.getMonth()+1;
        var date = now.getDate();
        var day = now.getDay();
        var hour = now.getHours();
        var min = now.getMinutes();
        var sec = now.getSeconds();
        if(month < 10) {
          month = "0" + month;
        }
        if(date < 10) {
          date = "0" + date;
        }
        if(hour < 10) {
          hour = "0" + hour;
        }
        if(min < 10) {
          min = "0" + min;
        }
        if(sec < 10) {
          sec = "0" + sec;
        }
        var time_str = "JST " + year + "/" + month + "/" + date + "/" + " " + hour + ":" + min + ":" + sec;
        // var time_str = "現在日時は「" + year + "年" + month + "月" + date + "日" + "（" + dayOfTheWeek[day] + "曜日）" + hour + "時" + min + "分" + sec + "秒」です。";
        target.text(time_str);
        setTimeout(function(){
          clock(target)
        },1000);
      }
  });
  
  jQuery.clock(jQuery("div.site-header__wrapper__right.top-links > p, div.mobile-nav__logo-title > p"));
});


/* function showCurrentTime() {
  const now = new Date();
  const hour = now.getHours();
  const minute = now.getMinutes();
  const second = now.getSeconds();
  const time = `現在の時刻は${hour}時${minute}分${second}秒です。`;
  document.getElementById('currentTime').textContent = time;
}
setInterval(showCurrentTime, 1000); */
/***** /date *****/





/***** cartbtn *****/
$(function () {
  var animeSpeed = 500;
  $("p.cartbtn a[href^='#']").on({
      "click": function () {
          var href = $(this).attr('href');
          var target = $(href == "#" || href === "" ? "html" : href);
          var position;
          position = target.offset().top - 480;
          $("body,html").stop().animate({
              scrollTop: position
          }, animeSpeed);
          return false;
      }
  });
});
/***** /cartbtn *****/





/***** address *****/
$(function () {
  $('body.template-customers-addresses a.account-section--btn').on({
    'click': function () {
      $(this).toggleClass('formopen');
    }
  });
});
$(function () {
  $('body.template-customers-addresses p.address_update a.account-section--btn, body.template-customers-addresses p.address_update_cancel a').on({
    'click': function () {
      $('a.account-section--btn').removeClass('formopen');
    }
  });
});
/***** /address *****/





/***** modaal *****/
/* template-index */
  document.addEventListener('DOMContentLoaded', function() {
    let count = 0;
    const destroy = setInterval(function() {
      const target = document.querySelector('.template-product .swiper-wrapper');
      count = count + 1;
      if (target) {
        clearInterval(destroy);
        $(function(){
          var modal = $(target);
          modal.on('click', function(){
            var cld = $(this).children('div').length;
            if (cld > 1) {
              var imgPath = $(this).children('.swiper-slide-active').children('div').children('div').children('img').prop('outerHTML');
            } else {
              var imgPath = $(this).children('div').children('div').children('div').children('img').prop('outerHTML');
            }
            $('#PageContainer').before('<section class="modal_inner modal_product"><div class="overlay"></div><div class="modal_product_img">' + imgPath + '<i class="fas fa-times-circle modal_close"></i></div></section>');
            $('.overlay, .modal_close').on('click', function(){
              $('.overlay').fadeOut(500);
              $('.modal_inner').fadeOut(100).remove();
            });
          });
        });
      }
    }, 10);
    setTimeout(function() {
      clearInterval(destroy);
    }, 20000);
  })
/* /template-index */
/***** /modaal *****/





/***** /filtering tag *****
$(document).ready(function(){

  if (location.href.match('BOOK')){
    $('.book').addClass('selected');
  } else if (location.href.match('DVD / Blu-ray')){
    $('.dvd-blu-ray').addClass('selected');
  } else {
    $('.filter_item_tag').removeClass('selected');
  }

});
***** /filtering tag *****/
